import { FinancialRounding } from 'partner360/models/financialRounding'

export const FIN_FRACTION_DIGITS = 0
export const FIN_FRACTION_DIGITS_ROUNDING = 2

export const FINANCIAL_ROUNDING_CONFIG = {
  [FinancialRounding.AsIs]: {
    divisor: 1,
    fractionDigits: FIN_FRACTION_DIGITS,
    suffix: '',
  },
  [FinancialRounding.K]: {
    divisor: 1_000,
    fractionDigits: FIN_FRACTION_DIGITS_ROUNDING,
    suffix: 'K',
  },
  [FinancialRounding.M]: {
    divisor: 1_000_000,
    fractionDigits: FIN_FRACTION_DIGITS_ROUNDING,
    suffix: 'M',
  },
} as const
